import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngxs/store';
import {Observable, Subscription} from 'rxjs';
import {AuthState} from '../../models/auth';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';

@Component({
  selector: 'app-not-found-template',
  templateUrl: './not-found-template.component.html',
  styleUrls: ['./not-found-template.component.scss']
})
export class NotFoundTemplateComponent implements OnInit, OnDestroy {
  isExpert$: Observable<boolean> = this.store.select<boolean>(AuthState.getIsExpert);
  @Input() navigateUrl: string;
  @Input() title = 'La página a la que estás queriendo acceder no existe';
  @Input() buttonText = 'Ir al dashboard';
  @Input() showButton = true;
  params: any;
  expertSuscription: Subscription;
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private utilitiesService: UtilitiesService,
    private store: Store
  ) { }

  ngOnInit(): void {
    this.expertSuscription = this.isExpert$.subscribe(isExpert => {
      this.params = this.utilitiesService.getAllParams(this.activatedRoute);
      this.navigateUrl = `/clinic/${this.params.clinicId}/summary`;
    });
  }

  onClick(): void {
    this.router.navigateByUrl(this.navigateUrl, { replaceUrl: true });
  }

  ngOnDestroy(): void {
    this.expertSuscription?.unsubscribe();
  }

}
